function fireEvent(action) {
	const e = document.createEvent('CustomEvent');
	e.initCustomEvent('acom-track-event', true, true, { action });
	parent.dispatchEvent(e); // The iframe doesn't have the tracking code so we need to dispatch this to the parent.
}

export default fireEvent;



// WEBPACK FOOTER //
// ./app/public/src/js/signin/frame/utils/fireEvent.js